"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeToSessions = exports.deleteSessionRealTime = exports.editSessionRealTime = exports.addSessionRealTime = exports.editSession = exports.deleteSession = exports.addSession = exports.fetchSessionById = exports.fetchSessions = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var supabaseClient_1 = require("../../supabaseClient"); // Adjust the import path as needed
var initialState = {
    data: [],
    session: {},
    status: "idle",
    error: null,
    globalData: {},
    loaded: false,
};
// Fetch all sessions
exports.fetchSessions = (0, toolkit_1.createAsyncThunk)("sessions/fetchSessions", function (_, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, data, error;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, supabaseClient_1.supabase.from("sessions").select("*")];
                case 1:
                    _b = _c.sent(), data = _b.data, error = _b.error;
                    if (error) {
                        return [2 /*return*/, rejectWithValue(error.message)];
                    }
                    return [2 /*return*/, data];
            }
        });
    });
});
// Fetch session by ID
exports.fetchSessionById = (0, toolkit_1.createAsyncThunk)("sessions/fetchSessionById", function (sessionId, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, data, error;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, supabaseClient_1.supabase
                        .from("sessions")
                        .select("*,patient:patients (*)")
                        .eq("id", sessionId)
                        .single()];
                case 1:
                    _b = _c.sent(), data = _b.data, error = _b.error;
                    // console.log({ data, error });
                    if (error || data.id !== sessionId) {
                        return [2 /*return*/, rejectWithValue(error.message)];
                    }
                    return [2 /*return*/, data];
            }
        });
    });
});
// Add a new session
exports.addSession = (0, toolkit_1.createAsyncThunk)("sessions/addSession", function (newSession, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, insertData, insertError;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("sessions")
                    .insert(newSession)
                    .select()
                    .single()];
            case 1:
                _a = _b.sent(), insertData = _a.data, insertError = _a.error;
                if (insertError) {
                    return [2 /*return*/, thunkApi.rejectWithValue(insertError.message)];
                }
                return [2 /*return*/, insertData];
        }
    });
}); });
// Delete a session
exports.deleteSession = (0, toolkit_1.createAsyncThunk)("sessions/deleteSession", function (id, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("sessions")
                    .delete()
                    .eq("id", id)];
            case 1:
                error = (_a.sent()).error;
                if (error) {
                    return [2 /*return*/, thunkApi.rejectWithValue(error.message)];
                }
                return [2 /*return*/, id];
        }
    });
}); });
// Edit a session
exports.editSession = (0, toolkit_1.createAsyncThunk)("sessions/editSession", function (updatedSession, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, updateData, updateError;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("sessions")
                    .update(updatedSession)
                    .eq("id", updatedSession.id)
                    .select()
                    .single()];
            case 1:
                _a = _b.sent(), updateData = _a.data, updateError = _a.error;
                if (updateError) {
                    return [2 /*return*/, thunkApi.rejectWithValue(updateError.message)];
                }
                return [2 /*return*/, updateData];
        }
    });
}); });
// Real-time actions
var addSessionRealTime = function (newSession) { return ({
    type: "sessions/addSessionRealTime",
    payload: newSession,
}); };
exports.addSessionRealTime = addSessionRealTime;
var editSessionRealTime = function (updatedSession) { return ({
    type: "sessions/editSessionRealTime",
    payload: updatedSession,
}); };
exports.editSessionRealTime = editSessionRealTime;
var deleteSessionRealTime = function (id) { return ({
    type: "sessions/deleteSessionRealTime",
    payload: id,
}); };
exports.deleteSessionRealTime = deleteSessionRealTime;
// Slice definition
var sessionsSlice = (0, toolkit_1.createSlice)({
    name: "sessions",
    initialState: initialState,
    reducers: {
        addSessionRealTime: function (state, action) {
            var exists = state.data.some(function (item) { return item.id === action.payload.id; });
            if (!exists) {
                state.data.push(action.payload);
            }
            state.error = null;
        },
        editSessionRealTime: function (state, action) {
            var index = state.data.findIndex(function (item) { return item.id === action.payload.id; });
            if (index !== -1) {
                var isDifferent = JSON.stringify(state.data[index]) !== JSON.stringify(action.payload);
                if (isDifferent) {
                    state.data[index] = action.payload;
                }
            }
            state.error = null;
        },
        deleteSessionRealTime: function (state, action) {
            state.data = state.data.filter(function (item) { return item.id !== action.payload; });
            state.error = null;
        },
    },
    extraReducers: function (builder) {
        builder
            .addCase(exports.fetchSessions.pending, function (state) {
            state.status = "loading";
        })
            .addCase(exports.fetchSessions.fulfilled, function (state, action) {
            state.loaded = true;
            state.data = action.payload;
            action.payload.forEach(function (item) {
                var _a;
                state.globalData[(_a = item.id) !== null && _a !== void 0 ? _a : ""] = item;
            });
            state.status = "succeeded";
        })
            .addCase(exports.fetchSessions.rejected, function (state, action) {
            state.status = "failed";
            state.error = action.payload || "Failed to fetch sessions.";
        })
            .addCase(exports.fetchSessionById.pending, function (state) {
            state.session = {};
            state.status = "loading";
        })
            .addCase(exports.fetchSessionById.fulfilled, function (state, action) {
            state.loaded = true;
            state.session = action.payload;
            state.status = "succeeded";
        })
            .addCase(exports.fetchSessionById.rejected, function (state, action) {
            state.status = "failed";
            state.session = {};
            state.error =
                action.payload || "Failed to fetch session by ID.";
        })
            .addCase(exports.addSession.fulfilled, function (state, action) {
            state.data.push(action.payload);
            state.error = null;
        })
            .addCase(exports.addSession.rejected, function (state, action) {
            state.error = action.payload || "Failed to add session.";
        })
            .addCase(exports.deleteSession.fulfilled, function (state, action) {
            state.data = state.data.filter(function (item) { return item.id !== action.payload; });
            state.error = null;
        })
            .addCase(exports.deleteSession.rejected, function (state, action) {
            state.error = action.payload || "Failed to delete session.";
        })
            .addCase(exports.editSession.fulfilled, function (state, action) {
            var index = state.data.findIndex(function (item) { return item.id === action.payload.id; });
            if (index !== -1) {
                state.data[index] = action.payload;
            }
            state.error = null;
        })
            .addCase(exports.editSession.rejected, function (state, action) {
            state.error = action.payload || "Failed to edit session.";
        });
    },
});
// Real-time subscription function
var subscribeToSessions = function (dispatch) {
    var subscription = supabaseClient_1.supabase
        .channel("public:sessions")
        .on("postgres_changes", { event: "*", schema: "public", table: "sessions" }, function (payload) {
        var _a;
        var newRecord = payload.new;
        var oldRecord = payload.old;
        switch (payload.eventType) {
            case "INSERT":
                dispatch((0, exports.addSessionRealTime)(newRecord));
                break;
            case "UPDATE":
                dispatch((0, exports.editSessionRealTime)(newRecord));
                break;
            case "DELETE":
                dispatch((0, exports.deleteSessionRealTime)((_a = oldRecord.id) !== null && _a !== void 0 ? _a : ""));
                break;
            default:
                break;
        }
    })
        .subscribe();
    return function () {
        subscription.unsubscribe();
    };
};
exports.subscribeToSessions = subscribeToSessions;
exports.default = sessionsSlice.reducer;
